import { Alert, Form } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import variables from "../../../styles/utils.module.scss";
import CheckboxWithLabel from "../../../components/CheckboxWithLabel";
import axios from "axios";
import { getMessagesUserType, serverUrl } from "../../../helpers/utility";
import { mutate } from "swr";
import InputWithLabel from "../../../components/inputWithLabel";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

function EnquiryModal({ placement, location, show, close, size, user }) {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
    setError,
    clearErrors,
    trigger,
    reset,
  } = useForm();
  const formValues = watch();
  const [sent, markSent] = useState(false);
  const [enquiryData, setEnquiryData] = useState(null);
  let navigate = useNavigate();

  if (typeof close !== "function") {
    console.error(`Enquiry missing close function!`);
    return <></>;
  }

  useEffect(() => {
    return () => {
      resetModal();
    };
  }, []);

  function resetModal() {
    markSent(false);
    setEnquiryData(null);
    reset();
  }

  function viewEnquiry() {
    navigate(`/enquiry?enquiryId=${enquiryData?._id}`);
    resetModal();
  }

  async function sendEnquiry() {
    try {
      console.log(`sendEnquiry`);

      const response = await axios.put(`${serverUrl}/enquiry`, {
        placementId: placement._id,
        careProviderLocationId: location._id,
        careProviderOrganisationId: location.careProviderOrganisationId,
        informationSharing: formValues.informationSharing,
        messages: [
          {
            created: new Date(),
            message: formValues.message,
            userId: user._id,
            userType: getMessagesUserType(user),
          },
        ],
      });

      if (response && response?.data?.result?._id) {
        markSent(true);
        setEnquiryData(response.data.result);
      }
    } catch (error) {
      console.error(`Enquiry error: ${error}`);
      close();
    }
  }

  return (
    <Modal show={show} onHide={close} size={size || "lg"}>
      <Modal.Header closeButton>
        <Modal.Title>Provider Enquiry</Modal.Title>
      </Modal.Header>

      {!sent ? (
        <>
          <Modal.Body>
            <Form>
              <InputWithLabel
                inputId={`message`}
                label={`Message`}
                placeholder={`A message to send to ${location?.name}.`}
                type="textarea"
                inputProps={{ rows: 5 }}
                register={register}
              />

              <CheckboxWithLabel
                inputId={`informationSharing`}
                label={`Share information about ${
                  placement?.firstname || placement?.reference
                } with ${location?.name} to help determine suitability (Optional).`}
                type="checkbox"
                register={register}
              />
            </Form>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                close();
                resetModal();
              }}
            >
              Close
            </Button>
            <Button variant="primary" onClick={sendEnquiry}>
              Send
            </Button>
          </Modal.Footer>
        </>
      ) : null}

      {sent ? (
        <>
          <Modal.Body>
            <Alert variant="success">Enquiry has been sent.</Alert>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                close();
                resetModal();
              }}
            >
              Close
            </Button>
            <Button variant="primary" onClick={viewEnquiry}>
              View
            </Button>
          </Modal.Footer>
        </>
      ) : null}
    </Modal>
  );
}

export default EnquiryModal;
